import ApiService from "@/common/api.service";
import { FETCH_BANKS } from "../actions.type";
import { SET_BANKS } from "../mutations.type";

const state = {
  banks: []
};

const getters = {
  banks(state) {
    return state.banks;
  }
};

const mutations = {
  [SET_BANKS](context, newbanks) {
    state.banks = newbanks;
  }
};

const actions = {
  [FETCH_BANKS](context, reload = false) {
    if (state.banks.length > 0 && !reload)
      return Promise.resolve(context.banks);

    return ApiService.get("banks/list").then(banks => {
      context.commit(SET_BANKS, banks);
      return Promise.resolve(banks);
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
